import { useCallback, useEffect, useMemo } from 'react';
import { useApiCall } from 'use-api-call';

const useImmediateApiCall = <T>(
  request: string | ((...args: any[]) => Promise<T>)
) => {
  const { data, loading, error, invoke } = useApiCall(request);

  const fetchApi = useCallback(() => {
    if (!data && !loading) {
      invoke();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return useMemo(
    () => ({
      data: data as T,
      error,
      loading,
      retry: invoke,
    }),
    [data, loading, error, invoke]
  );
};

export default useImmediateApiCall;
